// localStorage and sessionStorage can be missing or throw: a private window,
// blocked site data, an app's web view. Nothing here may stop a page drawing.

export function readStorage(kind, key) {
  try {
    return window[kind].getItem(key);
  } catch (e) {
    return null;
  }
}

export function writeStorage(kind, key, value) {
  try {
    window[kind].setItem(key, value);
  } catch (e) {
    // Not remembered; the page still works.
  }
}

// The site's language switch (the header) keeps "en" or "ar" here.
export function isArabic() {
  return readStorage("localStorage", "language") === "ar";
}

// Leaves this page for `address` without leaving it in the history, so Back
// skips it. Its own function so the tests can see where a page was sent.
export function replaceLocation(address) {
  window.location.replace(address);
}
